import { useTranslation } from 'react-i18next';

import { TDealColumn } from '@crm/entities/deals-board';
import { toastManager } from '@crm/entities/toast';

import { useDeleteColumnMutation } from '../../api';

export const useDeleteColumn = ({
    columnId,
    isEmpty,
}: {
    columnId: TDealColumn['id'];
    isEmpty: boolean;
}) => {
    const { t } = useTranslation();
    const deleteColumnMutation = useDeleteColumnMutation();

    const onDeleteColumn = async () => {
        if (!isEmpty) {
            toastManager.onError({
                title: t('crm.deals.board.column.deleteNotEmptyError'),
                duration: 5000,
            });
            return;
        }
        await deleteColumnMutation.mutateAsync({ columnId });
    };

    return {
        onDeleteColumn,
    };
};
